// MUNYA OS · Diccionario central de etiquetas enum→español · #390 §5.8
//
// Regla: ningún valor de máquina llega al usuario. Todo enum que se pinte en la
// interfaz se da de alta aquí; lo que no tenga etiqueta se muestra Capitalizado
// y sin guiones bajos como fallback (labelize). Mismo espíritu que el diccionario
// bloque→icono de #387 (panel-sections.ts): un mapa único, no decisión de cada vista.
//
// Los mapas específicos ya consolidados (STAGE_LABEL del CRM, EVENT_KIND_LABEL del
// calendario, PRIO_LABEL del TRACK…) siguen siendo la fuente en sus módulos; este
// diccionario cubre los valores que hoy llegan crudos y sirve de fallback común.

export const VALUE_LABELS: Record<string, string> = {
  // Tipologías (honorarios/proyecto/lead)
  vivienda: 'Vivienda',
  tienda: 'Tienda',
  restaurante: 'Restaurante',
  hotel: 'Hotel',
  stand_feria: 'Stand de feria',
  consultoria_independiente: 'Consultoría independiente',
  // Intervenciones
  decoracion_amueblado: 'Decoración y amueblado',
  decoracion: 'Decoración',
  reforma: 'Reforma',
  reforma_integral: 'Reforma integral',
  obra_nueva: 'Obra nueva',
  rehabilitacion: 'Rehabilitación',
  feria: 'Feria',
  // Estado de proyecto
  active: 'Activo',
  paused: 'En pausa',
  completed: 'Completado',
  archived: 'Archivado',
  // Prioridades (tareas/proyecto)
  low: 'Baja',
  medium: 'Media',
  high: 'Alta',
  urgent: 'Urgente',
  // Roles de equipo en proyecto
  owner: 'Responsable',
  editor: 'Editor',
  observer: 'Observador',
  // Tipos de evento de calendario
  site_visit: 'Visita de obra',
  store_visit: 'Visita a tiendas', // #430
  team_meeting: 'Reunión de equipo',
  client_meeting: 'Reunión con cliente',
  business_trip: 'Viaje de trabajo',
  delivery_milestone: 'Entrega',
  decision_milestone: 'Hito de decisión',
  // Estados genéricos
  pending: 'Pendiente',
  in_progress: 'En curso',
  done: 'Hecho',
  todo: 'Pendiente',
  draft: 'Borrador',
  sent: 'Enviada',
  paid: 'Pagada',
  overdue: 'Vencida',
  cancelled: 'Anulada',
  // Solicitudes (vacaciones/ausencias/correcciones)
  approved: 'Aprobada',
  rejected: 'Rechazada',
  // Tipos de ausencia
  vacation: 'Vacaciones',
  unpaid: 'No retribuido',
  compensation_day: 'Día por horas extra',
  personal: 'Asuntos propios',
  sick_leave: 'Baja médica',
  other: 'Otro',
  // Estado de proyecto / tareas de obra / fases
  in_construction: 'En obra',
  planned: 'Planificada',
  blocked: 'Bloqueada',
  review: 'En revisión',
  closed: 'Cerrada',
  // Facturación / contratos
  issued: 'Emitida',
  ready_to_issue: 'Lista para emitir',
  signed: 'Firmado',
  superseded: 'Sustituido',
  // Logística de pedidos
  confirmed: 'Confirmado',
  received: 'Recibido',
  shipped: 'Enviado',
  // Import A3 (contabilidad)
  uploaded: 'Subido',
  parsed: 'Procesado',
  reconciled: 'Conciliado',
  failed: 'Fallido',
  // Modelos de pricing (fallback; hay mapa local en Administración)
  commercial_with_pro_discount: 'Comercial con DTO pro',
  professional_only: 'Solo profesional',
  // Roles de estudio (fallback; hay mapa local ROLE_LABEL)
  studio_admin: 'Dirección · Admin',
  studio_director: 'Dirección',
  studio_designer: 'Diseño',
  studio_management: 'Gestión',
  external_gestoria: 'Gestoría externa',
  designer: 'Diseñador',
  accounting: 'Contabilidad',
  // Calendario
  training_session: 'Formación',
};

/** Capitaliza y limpia guiones bajos: fallback para enums sin etiqueta. */
export function labelize(value: string | null | undefined): string {
  if (!value) return '—';
  const known = VALUE_LABELS[value];
  if (known) return known;
  const clean = value.replace(/_/g, ' ').trim();
  return clean.charAt(0).toUpperCase() + clean.slice(1);
}
